import { h, Fragment } from 'preact'
import { StepBody } from '../step-body'
import { SelfSchedulerFooter } from '../self-scheduler-footer'
import { BookingStep } from '../../models/enums'
import { bookingErrorIcon } from '../../shared/svgIcons'

import * as style from '../booked/style.css'

const BookingErrored: preact.FunctionalComponent = () => {
    return (
        <Fragment>
            <section class={style.booked}>
                <StepBody>
                    <div class={style.bookedBody}>
                        <div class={style.bookedIcon}>{bookingErrorIcon()}</div>
                        <h2 class={style.bookedTitle}>Please go back and select a different appointment.</h2>
                    </div>
                </StepBody>
                <SelfSchedulerFooter backStep={BookingStep.DATETIME} />
            </section>
        </Fragment>
    )
}

export default BookingErrored
